import { Link } from 'react-router-dom';
import { EVENT_TYPES, formatRange, eventStatus, relativeLabel, eventColor } from '../lib/format.js';

export default function EventCard({ event }) {
  const status = eventStatus(event);
  const accent = eventColor(event);

  return (
    <Link to={`/event/${event.slug}`} className="card" style={{ '--card-accent': accent }}>
      <div className="card__top">
        <span className="badge" style={{ '--badge-color': accent }}>
          {EVENT_TYPES[event.eventType] ?? EVENT_TYPES.other}
        </span>
        {status === 'live'
          ? <span className="badge badge--live">Live</span>
          : <span className="badge badge--soft">{relativeLabel(event)}</span>}
      </div>

      <div>
        <div className="card__title">{event.title}</div>
        <div className="card__meta">{formatRange(event.startsAt, event.endsAt)}</div>
      </div>

      {event.summary
        ? <p className="card__summary">{event.summary}</p>
        : (
          /* Termin steht, Inhalt noch nicht: Das ist eine Aussage und keine
             Lücke — Niantic kündigt die Pokémon oft erst wenige Tage vorher
             an. Besser als ein leerer Platz oder eine interne Notiz. */
          <p className="card__summary text-faint">
            Termin steht, Einzelheiten sind noch nicht angekündigt.
          </p>
        )}

      {event.bonuses?.length > 0 && (
        <div className="card__foot">
          {event.bonuses.slice(0, 3).map((bonus) => (
            <span key={bonus} className="badge badge--soft" title={bonus}>{bonus}</span>
          ))}
          {event.bonuses.length > 3 && (
            <span className="badge badge--soft" title={event.bonuses.slice(3).join(' · ')}>
              +{event.bonuses.length - 3}
            </span>
          )}
        </div>
      )}
    </Link>
  );
}
